import EnvelopeIcon from "@heroicons/react/24/solid/EnvelopeIcon";
import PhoneIcon from "@heroicons/react/24/solid/PhoneIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import Check from "@mui/icons-material/Check";
import { MenuItem } from "@mui/material";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import PhoneInput from "react-phone-number-input";
import Color from "../../../assets/colors";

export const DialogContainer = styling(Dialog)({
  ".MuiDialog-paper": {
    borderRadius: "8px",
    overflowX: "clip",
    minWidth: "18.5rem",
    margin: "0 1.5rem",
  },
});

export const CardContainer = styling(Box)({
  minWidth: "37.5rem",
  width: "100%",
  height: "100%",

  overflow: "clip",

  "@media (max-width: 640px)": {
    minWidth: "18.5rem",
  },
});

export const BoxContainer = styling(Box)({
  display: "flex",
  width: "100%",
});

export const ScrollContainer = styling(Box)({
  display: "flex",
  width: "100%",
  height: "50svh",

  overflowY: "scroll",
  overflowX: "clip",
  maxHeight: "32.25rem",

  "@media (max-width: 640px)": {
    maxHeight: "23.875rem",
  },

  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: "transparent",
    width: 3,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    borderRadius: 8,
    backgroundColor: Color.hiredlyPurple,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-track": {
    height: "3.25rem",
  },
});

export const TextStyled = styling(Typography)({});

export const TextFieldStyled = styling(TextField)({
  width: "100%",

  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderRadius: "0.5rem",
      border: `1px solid ${Color.grey}`,
      transition: "all 0.15s ease-in-out",
    },

    "&:hover fieldset": {
      border: `1px solid ${Color.hiredlyPurple}`,
    },

    "&.Mui-focused fieldset": {
      border: `1px solid ${Color.hiredlyPurple}`,
    },

    "@media (max-width: 640px)": {
      fontSize: "0.875rem",
    },
  },
  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: Color.error,
  },
});

export const PhoneInputStyled = styling(PhoneInput)((props) => ({
  display: "flex",
  alignItems: "center",

  border: props?.error ? `2px solid ${Color.error}` : `2px solid ${Color.grey}`,
  borderRadius: "0.5rem",
  padding: "0px",
  width: "16.75rem",
  height: "3rem !important",
  backgroundColor: Color.white,

  overflow: "clip",

  "@media (max-width: 640px)": {
    width: "auto",
    height: "2.5rem",
    // padding: "0.5rem",
  },

  "& .PhoneInputInput": {
    fontFamily: "Inter",
    fontSize: "1rem",
    flex: "1",
    height: "100%",
    border: "none",
    background: Color.white,

    "@media (max-width: 640px)": {
      fontSize: "0.875rem",
    },
  },

  "& .PhoneInputInput:focus": {
    outline: "none",
  },

  "& .PhoneInputCountryIcon": {
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
  },

  "& .PhoneInputCountryIconImg": {
    width: "24px",
    height: "100%",
    borderRadius: "0.3rem",
  },

  "& .PhoneInputInternationalIconPhone": {
    opacity: "0.8",
  },

  "& .PhoneInputInternationalIconGlobe": {
    opacity: "0.65",
  },

  "& .PhoneInputCountry": {
    position: "relative",
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    padding: 0,
    width: "100%",
    maxWidth: "68px",
    height: "100%",
    minHeight: "36px",
    borderRadius: "8px 0px 0px 8px",
    background: "rgba(81, 42, 204, 0.1)",
  },

  "& .PhoneInputCountrySelect": {
    position: "absolute",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    zIndex: "1",
    border: "0",
    opacity: "0",
    cursor: "pointer",
  },

  "& .PhoneInputCountrySelectArrow": {
    display: "block",
    content: '""',
    width: "0.3em",
    height: "0.3em",
    margin: "0 0.25em 0.4em 0.35em",
    borderStyle: "solid",
    borderColor: "inherit",
    borderTopWidth: "0",
    borderBottomWidth: "1px",
    borderLeftWidth: "0",
    borderRightWidth: "1px",
    transform: "rotate(45deg)",
    opacity: "0.45",
  },
}));

export const CheckboxStyled = styling(Checkbox)({
  padding: "0px",
  "& .Mui-checked": {
    color: Color.black,
  },

  "&:hover": {
    background: "transparent",
  },
});

export const SelectStyled = styling(Select)({
  width: "100%",

  "&.MuiOutlinedInput-root": {
    maxHeight: "3rem",
    fieldset: {
      borderRadius: "0.5rem",
      border: `1px solid ${Color.grey}`,
      transition: "all 0.15s ease-in-out", // Default border thickness
    },
    "&.MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${Color.hiredlyPurple}`,
    },
    "&:hover": {
      fieldset: {
        border: `1px solid ${Color.hiredlyPurple}`,
      },
    },
    "&.Mui-focused": {
      fieldset: {
        border: `1px solid ${Color.hiredlyPurple}`,
      },
    },

    "@media (max-width: 640px)": {
      fontSize: "0.875rem",
      maxHeight: "2.5rem",
    },
  },
});

export const OptionStyled = styling(MenuItem)({});

export const CloseButton = styling(ButtonBase)({});

export const CancelButtonStyled = styling(ButtonBase)({
  fontSize: "14px",
  fontWeight: "600",
  fontFamily: "Inter",
  border: `1px solid ${Color.black}`,

  backgroundColor: Color.white,
  color: Color.black,

  padding: "0px 16px",
  borderRadius: "0.5rem",
  height: "36px",

  transition: "all 0.15s ease-in-out",

  ":disabled": {
    opacity: "0.5",
  },
});

export const ButtonStyled = styling(ButtonBase)({
  fontSize: "14px",
  fontWeight: "600",
  fontFamily: "Inter",

  backgroundColor: Color.buttonGrey,
  color: Color.white,

  padding: "0px 16px",
  borderRadius: "0.5rem",
  height: "36px",

  transition: "all 0.15s ease-in-out",

  ":disabled": {
    opacity: "0.5",
  },
});

export const CloseIcon = styling(XMarkIcon)({
  height: "24px",
  width: "24px",
});

export const CallIcon = styling(PhoneIcon)({
  height: "16px",
  width: "16px",
});

export const EmailIcon = styling(EnvelopeIcon)({
  height: "16px",
  width: "16px",
});

export const UncheckedIcon = styling(Box)({
  width: "16px",
  height: "16px",
  borderRadius: "4px",
  border: `1px solid ${Color.grey}`,
});

export const CheckedIcon = styling(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  width: "16px",
  height: "16px",
  borderRadius: "4px",
  border: `1px solid ${Color.grey}`,
  backgroundColor: Color.black,
});

export const CheckStyled = styling(Check)({
  height: "14px",
  width: "14px",
  color: Color.white,
});
